import { Component, OnDestroy, OnInit, ViewChild, ViewChildren, ElementRef, QueryList, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { jsPDF } from 'jspdf';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
// ✅ CHANGED: Removed IServerSideGetRowsParams (wrong for infinite model)
//             Added IDatasource + IGetRowsParams (correct for rowModelType: "infinite")
//             Removed GridOptions (use plain object with theme instead)
import { IDatasource, IGetRowsParams } from 'ag-grid-community';



import { QrExportService } from 'src/app/_services/qr-export.service';
import { ServerRequest } from 'src/app/_models/global.data.model';
import { TableHeaderToolTipComponent } from 'src/app/shared/table-header-tool-tip/table-header-tool-tip.component';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ProductService } from 'src/app/_services/product.service';

var dateFormateChange: any;

@Component({
  selector: 'app-product-bulk-export-qr',
  templateUrl: './product-bulk-export-qr.component.html',
  styleUrls: ['./product-bulk-export-qr.component.scss'],
  standalone: false,
})
export class ProductBulkExportQrComponent extends SubscriptionUtil implements OnInit, OnDestroy, AfterViewChecked {
  translate: any;
  submitTouched: boolean = true;

  fileFormat: any = [
    { name: 'PDF', value: 'pdf' },
    { name: 'PNG(Zip File)', value: 'png' },
  ];

  qrCodeSize: any = [
    { name: '0.75" (19mm) - Compact', value: 'small' },
    { name: '1" (25mm) - Standard', value: 'medium' },
    { name: '1.5" (38mm) - Large', value: 'large' },
    { name: '2" (50mm) - Extra Large', value: 'xlarge' },
  ];

  pageLayout: any = [
    { name: '4 per page (2x2)', value: 'portrait' },
    { name: '6 per page (2x3)', value: 'landscape' },
    { name: '12 per page (3x4)', value: 'a4' },
    { name: '24 per page (4x6)', value: 'a5' },
  ];

  filePageLayout: any;
  private sizeMmMap: any = { small: 19, medium: 25, large: 38, xlarge: 50 };

  exportData: any = {
    selectedFileFormat: null,
    selectedQrCodeSize: null,
    selectedPageLayout: null,
  };

  products: any[] = [];
  productName!: string;
  selectedProduct: any;
  displayProductTable: boolean = false;

  productTypes: any;
  productStatus: any;
  dateRange!: any;
  filter: any = {
    productTypeIds: null,
    productFamilyIds: null,
    fromDate: null,
    toDate: null,
    isActive: null,
  };

  @ViewChild('myCalendar', { static: false })
  private myCalendar: any;

  @ViewChildren('qrItem', { read: ElementRef })
  private qrItems!: QueryList<ElementRef>;

  //======= Grid Variables =======
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any = [];
  defaultColDef: any;
  gridParams: any;
  startFrom: any;
  product: any;
  pageSize: any = 25;
  parameters: any;
  // ✅ CHANGED: plain object instead of Partial<GridOptions> — theme added
  gridOptions: any;
  overlayNoRowsTemplate!: any;
  currentRecordNumber: any;
  rowSelection: any = "multiple";
  //---- Grid Variables End ----

  totalRecords: any;
  noAssets: boolean = false;
  noAssetsIcon: boolean = false;
  loadTable: number = 0;
  searchValue: any;
  bodyHeight!: number;

  @ViewChild('topElement')
  topElement!: ElementRef;
  bodyHeightleft!: number;

  qrexportForm: UntypedFormGroup;
  selectAllChecked: boolean = false;
  selectedProductData: any[] = [];
  submitFromData: any = {
    selectedIds: [],
    selectedAll: false,
    search: "",
    productTypeIds: null,
    productFamilyIds: null,
    createdFrom: null,
    createdTo: null,
  };
  selectedproductSKUs: any[] = [];
  selectedIdSet: Set<string> = new Set();
  searchValueData: boolean = false;
  productsFamilies: any[] = [];

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private qrExportService: QrExportService,
    private cdr: ChangeDetectorRef,
    private auth: AuthenticationService,
    private util: UtilServiceService,
    private productService: ProductService,
  ) {
    super();

    this.gridOptions = {
      pagination: true,
      cacheBlockSize: 25,
      rowModelType: 'infinite',
      sortingOrder: ["desc", "asc"],
      onGridSizeChanged: (params: any) => {
        params.api.sizeColumnsToFit();
      },
      tooltipShowDelay: 100,
      rowSelection: 'multiple',
      rowMultiSelectWithClick: true,
      onRowSelected: (e: any) => this.onRowSelected(e),
      onSelectionChanged: () => this.onSelectionChanged(),
     
    };

    this.defaultColDef = {
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: false,
      tooltipComponent: TableHeaderToolTipComponent,
    };

    this.qrexportForm = new UntypedFormGroup({
      fileFormat: new UntypedFormControl(null, [Validators.required]),
      qrCodeSize: new UntypedFormControl(null, [Validators.required]),
      pageLayout: new UntypedFormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    dateFormateChange = this.auth.getUserTimezone();
    this.filePageLayout = _.cloneDeep(this.pageLayout);
    this.getLanguageData();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewChecked() {
    this.bodyHeight = window.innerHeight - this.topElement.nativeElement.offsetHeight - 350;
    this.bodyHeightleft = window.innerHeight - this.topElement.nativeElement.offsetHeight - 180;
    this.cdr.detectChanges();
  }

  /********************************** Language *****************************/
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.initializeColumns();
          this.getFilterData();
        }
      })
    );
  }

  /********************************** Initialize Columns **************************/
  initializeColumns() {
    this.columnDefs = [];
    this.overlayNoRowsTemplate =
      "<div class='not-found-image'><span>" +
      "<img src='assets/svg/empty-state.svg' alt='No Records Found' />" +
      this.translate?.general.messages.noRecordsFound +
      "</span> </div>";

    const newData = [
      {
        headerName: this.translate?.product.fields.name.singular,
        field: "name",
        width: 80,
        headerTooltip: "#",
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.data) {
            return params.data.name ? params.data.name : "-";
          }
        },
      },
      {
        headerName: this.translate?.product.fields.sku.singular,
        field: "productSku",
        width: 80,
        headerTooltip: "#",
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.data) {
            return params.data.productSku ? params.data.productSku : "-";
          }
        },
      },
      {
        headerName: this.translate?.product.fields.type.singular,
        field: "productType.label",
        width: 80,
        headerTooltip: "#",
        resizable: true,
      },
      {
        headerName:
          this.translate?.product.label.singular + ' ' + this.translate?.product.fields.family.singular,
        field: "productFamily.label",
        width: 80,
        headerTooltip: "#",
        resizable: true,
      },
      {
        headerName: this.translate?.asset.fields.createdDate.singular,
        field: "createdDate",
        width: 80,
        headerTooltip: "#",
        resizable: true,
        valueFormatter: this.dateFormateChange,
      },
      {
        headerName: this.translate?.asset.fields.status.singular,
        field: "active",
        width: 80,
        headerTooltip: "#",
        resizable: true,
        cellRenderer: (params: any) => {
          if (params.data) {
            if (params.data.active === false) {
              return (
                '<span class="p-mr-2  p-tag p-component p-tag-danger" ><span class="p-tag-value text-dark">' +
                this.translate.general.status.inactive.singular +
                '</span></span>'
              );
            } else {
              return (
                '<span class="p-mr-2  p-tag p-component p-tag-success" ><span class="p-tag-value">' +
                this.translate.general.status.active.singular +
                '</span></span>'
              );
            }
          }
        },
      },
      {
        headerName: this.translate?.general.buttons.select2.singular,
        field: "",
        width: 80,
        headerClass: 'marging-auto hide-action-border',
        headerTooltip: "#",
        cellStyle: (params: any) => {
          if (params.data) {
            return params.data.disabled
              ? { 'pointer-events': 'none', opacity: '0.4' }
              : { 'pointer-events': 'auto', opacity: '1' };
          }
        },
        checkboxSelection: true,
      },
    ];

    this.columnDefs = newData;
    this.loadTable = 1;

    // ✅ CHANGED: removed deprecated gridOptions.api.setColumnDefs()
    //             use setGridOption("columnDefs") via the real gridApi instead
    if (this.gridApi) {
      this.gridApi.setGridOption("columnDefs", this.columnDefs);
      this.gridApi.sizeColumnsToFit();
      this.onGridReady(this.gridParams);
    }
  }

  dateFormateChange(params: any) {
    if (params.data) {
      if (params.data.createdDate !== undefined && params.data.createdDate !== null) {
        var dateFormat: any = localStorage.getItem('date_format');
        return moment.tz(params.data.createdDate, dateFormateChange).format(' hh:mm A ' + dateFormat.toUpperCase());
      } else {
        return '-';
      }
    }
  }

  /********************************** Filter Data **************************/
  getFilterData() {
    this.push(
      this.productService.getAllProductFamilies().subscribe((res: any) => {
        this.productsFamilies = [...res];
      })
    );
    this.push(
      this.productService.getAllProductType().subscribe((res: any) => {
        this.productTypes = res;
      })
    );
  }

  /********************************** Date Change **************************/
  public onDateChange(event: any) {
    if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
      this.filter.fromDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
      this.filter.toDate = moment(this.dateRange[1]).format("YYYY-MM-DD");
      this.myCalendar.hideOverlay();
      this.quickSearch();
    }

    if (event === null) {
      this.filter.fromDate = null;
      this.filter.toDate = null;
      this.quickSearch();
    }
  }

  push(obs: any) {
    super.push(obs);
  }

  /********************************** Search **************************/
  setSearch() {
    if (this.searchValue.length > 0) {
      this.searchValueData = true;
      this.quickSearch();
    }
  }

  public onSearch() {
    if (this.searchValue.length == 0) {
      this.searchValueData = false;
      this.searchValue = '';
      this.quickSearch();
    }
  }

  public onClear() {
    this.searchValueData = false;
    this.searchValue = '';
    this.quickSearch();
  }

  quickSearch() {
    this.onGridReady(this.gridParams);
  }

  /********************************** On Grid Ready **************************/
  onGridReady(params: any) {
    if (params != undefined) {
      this.gridParams = params;
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();

      // ✅ CHANGED: IDatasource with IGetRowsParams (infinite row model)
      const dataSource: IDatasource = {
        getRows: (params: IGetRowsParams) => {
          if (this.loadTable == 1) {
            this.getServerSideData(params);
          }
        },
      };

      // ✅ CHANGED: setGridOption("datasource") replaces deprecated setDatasource()
      this.gridApi.setGridOption("datasource", dataSource);
    }
  }

  /********************************** Get Server Side Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  getServerSideData(agGridGetRowsParams: IGetRowsParams) {
    this.gridApi.hideOverlay();
    const serverRequest = this.getRequestParams(agGridGetRowsParams);

    this.push(
      this.qrExportService
        .getProductListByFilter(
          this.searchValue,
          this.filter.productTypeIds,
          this.filter.productFamilyIds,
          this.filter.fromDate,
          this.filter.toDate,
          serverRequest
        )
        .subscribe(
          (data: any) => {
            this.products = data.body.data;
            this.totalRecords = data.body.total;
            this.setGridData(agGridGetRowsParams, this.products, data.body.total, data.body.status);
          },
          (err) => {
            this.errorUtil.setErrorMessage(err);
          }
        )
    );
  }

  /********************************** Set Grid Data **************************/
  // ✅ CHANGED: IServerSideGetRowsParams → IGetRowsParams
  // ✅ NOTE: successCallback already used here — kept as-is (this component was partially ahead)
  private setGridData(
    agGridGetRowsParams: IGetRowsParams,
    resultItems: any[],
    totalCount: number,
    status: string
  ) {
    if (status === "NO_DATA") {
      this.noAssets = false;
      this.noAssetsIcon = true;
      this.gridApi.showNoRowsOverlay();
    } else {
      this.noAssets = true;
      this.noAssetsIcon = false;

      if (this.products.length === 0) {
        this.gridApi.showNoRowsOverlay();
      } else {
        this.gridApi.hideOverlay();
        agGridGetRowsParams.successCallback(this.products, totalCount);
        this.restoreSelection();
      }
    }
  }

  /********************************** Request Params **************************/
  getRequestParams(agGridRequest: any): ServerRequest {
    if (agGridRequest.sortModel.length <= 0) {
      this.parameters = { colId: 'runningNo', sort: 'desc' };
      agGridRequest.sortModel.push(this.parameters);
    }

    this.currentRecordNumber = agGridRequest.startRow;
    return {
      startRow: agGridRequest.startRow,
      pageSize: 25,
      filterModel: null,
      sortModel: agGridRequest.sortModel,
    };
  }

  /********************************** Selection Restore **************************/
  private restoreSelection() {
    if (!this.gridApi) return;
    this.gridApi.forEachNode((node: any) => {
      const id = node?.data?.id;
      if (id == null) return;
      const shouldBeSelected = this.selectedIdSet.has(id);
      if (node.isSelected() !== shouldBeSelected) {
        node.setSelected(shouldBeSelected);
      }
    });
  }

  /********************************** Select All **************************/
  selectAll() {
    if (this.selectAllChecked) {
      this.overlayNoRowsTemplate =
        "<div class='not-found-image-asset'><span>" +
        this.totalRecords +
        " assets have been selected </span>" +
        "<img src='assets/svg/Asset-AllSelected.svg' alt='No Records Found' />" +
        '<span>Uncheck “select all” to view the whole list again</span></div>';

      if (this.gridApi) {
        setTimeout(() => {
          this.gridApi.showNoRowsOverlay();
        }, 500);
      }
    } else {
      this.overlayNoRowsTemplate =
        "<div class='not-found-image'><span>" +
        "<img src='assets/svg/empty-state.svg' alt='No Records Found' />" +
        this.translate?.general.messages.noRecordsFound +
        '</span> </div>';
      this.gridApi.hideOverlay();
    }
  }

  /********************************** Row Selection **************************/
  onRowSelected(event: any) {
    const id = event?.data?.id;
    if (id == null) return;
    if (event.node.isSelected()) this.selectedIdSet.add(id);
    else this.selectedIdSet.delete(id);
  }

  private onSelectionChanged() {
    const rows: any[] = [];
    this.gridApi.forEachNode((n: any) => {
      if (n.isSelected() && n.data) rows.push(n.data);
    });
    this.selectedProductData = rows;
  }

  /********************************** QR Code Size Change **************************/
  onQrCodeSizeChange() {
    this.exportData.selectedPageLayout = null;
    if (
      this.exportData.selectedQrCodeSize == 'large' ||
      this.exportData.selectedQrCodeSize == 'xlarge'
    ) {
      _.remove(this.filePageLayout, (n: any) => n.value == 'a5');
      return this.filePageLayout.filter((layout: any) => layout.value !== 'a5');
    } else {
      this.filePageLayout = _.cloneDeep(this.pageLayout);
    }
  }

  qrPixelSize(size: 'small' | 'medium' | 'large' | 'xlarge' | null) {
    switch (size) {
      case 'small': return 220;
      case 'medium': return 300;
      case 'large': return 450;
      case 'xlarge': return 600;
      default: return 300;
    }
  }

  trackByProduct = (_: number, a: any) => a?.id ?? a?.assetId ?? a?.assetCode ?? a;

  getQrPayload(serialNo: any): any {
    return serialNo;
  }

  /********************************** QR Collection **************************/
  private collectQrItems(): Array<{ url: string; label: string }> {
    const items: Array<{ url: string; label: string }> = [];
    this.qrItems?.forEach((el) => {
      const host = el.nativeElement as HTMLElement;
      const canvas = host.querySelector('canvas') as HTMLCanvasElement | null;
      const label = (
        host.getAttribute('data-label') ||
        host.querySelector('.qr-label')?.textContent ||
        ''
      ).trim();
      if (canvas) {
        items.push({ url: canvas.toDataURL('image/png'), label });
      }
    });
    return items;
  }

  /********************************** Layout Helper **************************/
  private gridForLayout(layout: 'portrait' | 'landscape' | 'a4' | 'a5') {
    switch (layout) {
      case 'portrait': return { cols: 2, rows: 2, orientation: 'p' as const };
      case 'landscape': return { cols: 3, rows: 2, orientation: 'l' as const };
      case 'a4': return { cols: 4, rows: 3, orientation: 'p' as const };
      case 'a5': return { cols: 6, rows: 4, orientation: 'l' as const };
      default: return { cols: 3, rows: 2, orientation: 'p' as const };
    }
  }

  /********************************** Export PDF **************************/
  private async exportPdfFromDataUrls(items: Array<{ url: string; label: string }>) {
    const sizeMm = this.sizeMmMap[this.exportData.selectedQrCodeSize];
    const { cols, rows, orientation } = this.gridForLayout(this.exportData.selectedPageLayout);
    const marginMm = 10;

    const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const cellW = (pageW - marginMm * 2) / cols;
    const cellH = (pageH - marginMm * 2) / rows;
    const qrBox = Math.min(cellW, cellH);
    const qrRenderMm = Math.min(qrBox, sizeMm);

    var textPadding = 10;
    if (this.exportData.selectedQrCodeSize === 'small') { textPadding = 7; doc.setFontSize(15); }
    else if (this.exportData.selectedQrCodeSize === 'medium') { doc.setFontSize(12); }
    else if (this.exportData.selectedQrCodeSize === 'large') { doc.setFontSize(14); }
    else if (this.exportData.selectedQrCodeSize === 'xlarge') { doc.setFontSize(14); }

    for (let i = 0; i < items.length; i++) {
      const idxOnPage = i % (cols * rows);
      const col = idxOnPage % cols;
      const row = Math.floor(idxOnPage / cols);
      if (i > 0 && idxOnPage === 0) doc.addPage();

      const x0 = marginMm + col * cellW;
      const y0 = marginMm + row * cellH;
      const qrX = x0 + (cellW - qrRenderMm) / 2;
      const qrY = y0 + (cellH - qrRenderMm) / 2;

      doc.addImage(items[i].url, 'PNG', qrX, qrY, qrRenderMm, qrRenderMm, undefined, 'FAST');

      const labelY = qrY + qrRenderMm + textPadding;
      const maxTextWidth = cellW - 4;
      const wrapped = doc.splitTextToSize(items[i].label || '', maxTextWidth);
      doc.text(wrapped, x0 + cellW / 2, labelY, { align: 'center' });
    }

    doc.save('SparePart-QR-Export.pdf');
    this.clearSelections();
  }

  /********************************** Export ZIP **************************/
  private async exportZipFromDataUrls(items: Array<{ url: string; label: string }>) {
    const zip = new JSZip();
    items.forEach((it, i) => {
      const safe = (it.label || `qr-${i + 1}`).replace(/[^\w.-]/g, '_');
      zip.file(`${safe}.png`, it.url.split(',')[1], { base64: true });
    });
    const blob = await zip.generateAsync({ type: 'blob' });
    saveAs(blob, 'SparePart-QR-Export.zip');
    this.clearSelections();
  }

  /********************************** Helpers **************************/
  disabledSelectAll(): boolean {
    if (this.dateRange || this.filter.productFamilyIds || this.filter.productTypeIds || this.searchValue) {
      return false;
    } else {
      return true;
    }
  }

  enableSubmit(): boolean {
    if (
      this.exportData.selectedFileFormat &&
      this.exportData.selectedQrCodeSize &&
      this.exportData.selectedPageLayout &&
      (this.selectedIdSet.size > 0 || this.selectAllChecked)
    ) {
      return false;
    } else {
      return true;
    }
  }

  /********************************** Submit **************************/
  submitForm() {
    if (this.selectAllChecked) {
      this.selectedProductData = [];
      this.selectedIdSet.clear();
    }
    this.spinner.show();
    var req = _.cloneDeep(this.submitFromData);

    req.selectedIds = this.selectedIdSet.size > 0 ? Array.from(this.selectedIdSet) : [];
    req.selectedAll = this.selectAllChecked;
    req.search = this.searchValue || null;
    req.productTypeIds = this.filter.productTypeIds ? this.filter.productTypeIds : null;
    req.productFamilyIds = this.filter.productFamilyIds ? this.filter.productFamilyIds : null;
    req.createdFrom = this.util
      .timeFormatter(
        moment("00:00:00", "h:mm A").format("h:mm A"),
        moment(this.filter.fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      )
      .toISOString();
    req.createdTo = this.util
      .timeFormatter(
        moment("00:00:00", "h:mm A").format("h:mm A"),
        moment(this.filter.toDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      )
      .toISOString();

    this.qrExportService.getProductSKUNumbers(req).subscribe(
      (res: any) => {
        if (res.status == 201 || res.status == 200) {
          this.selectedproductSKUs = res.body;
          setTimeout(() => { this.exportQrCodes(); }, 2000);
        } else {
          const title = this.errorUtil.processErrorTitle(res.error, this.translate);
          this.errorUtil.setErrorMessage(res.status, null, title, 'error', 3000);
          this.submitTouched = false;
        }
      },
      (err) => {
        this.spinner.hide();
        const title = this.errorUtil.processErrorTitle(err.error, this.translate);
        this.errorUtil.setErrorMessage(err.status, null, title, 'error', 3000);
      }
    );
  }

  /********************************** Export QR Codes **************************/
  async exportQrCodes() {
    try {
      await Promise.resolve();
      const items = this.collectQrItems();
      if (!items.length) {
        this.errorUtil.setErrorMessage(400, null, 'Could not render QR codes.', 'error', 2000);
        return;
      }
      if (this.exportData.selectedFileFormat === 'pdf') {
        await this.exportPdfFromDataUrls(items);
      } else {
        await this.exportZipFromDataUrls(items);
      }
    } catch (e) {
      this.errorUtil.setErrorMessage(400, null, e, 'error', 2000);
    } finally {
      this.spinner.hide();
    }
  }

  /********************************** Clear Selections **************************/
  clearSelections() {
    this.errorUtil.setErrorMessage(400, null, 'QR code(s) successfully downloaded', 'success', 2000);
    this.modalRef.hide();
    this.selectedIdSet.clear();
    this.selectedProductData = [];
    this.selectAllChecked = false;
    this.exportData.selectedAssets = [];
    this.filter.productTypeIds = null;
    this.filter.productFamilyIds = null;
    this.filter.fromDate = null;
    this.filter.toDate = null;
    this.searchValue = null;
    this.qrexportForm.reset();
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }

  clearFilter() {
    this.filter.productTypeIds = null;
    this.filter.productFamilyIds = null;
    this.filter.fromDate = null;
    this.filter.toDate = null;
    this.searchValue = null;
    this.searchValueData = false;
    this.dateRange = null;
    this.myCalendar?.hideOverlay();
    this.quickSearch();
  }

  clearSelect() {
    this.selectedIdSet.clear();
    this.selectedProductData = [];
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }
}